/* eslint-disable @typescript-eslint/no-explicit-any */

import { getConcentrationUnit } from "../../helper";

export const filterLabels: any = {
  materials: (option: any, t: any): { name: string; complement: string } => {
    return {
      name: `${t(option.translationKey)} | `,
      complement: `${t(option.materialCategory.translationKey)}`,
    };
  },
  materialCategories: (option: any, t: any): string => t(option.translationKey),
  medias: (option: any, t: any): { name: string; complement: string } => {
    return {
      name: `${t(option.translationKey)}${option.formula && ' - ' + option.formula} | `,
      complement: `${
        !Number.isNaN(Number(option.concentration)) && option.concentration !== ''
          ? `${option.concentration}${getConcentrationUnit(option.translationKey)} `
          : option.concentration
      }${option.temperature}°C`,
    };
  },
};

export const filterTrackings: any = {
  materials: (option: any): string => `${option.translationKey} | ${option.materialCategory.translationKey}`,
  materialCategories: (option: any): string => option.translationKey,
  medias: (option: any): string =>
    `${option.translationKey}${option.formula && ' - ' + option.formula} | ${
      !Number.isNaN(Number(option.concentration)) && option.concentration !== ''
        ? option.concentration + '% '
        : option.concentration
    }${option.temperature}°C`,
};

export const filterValues: any = {
  materials: (option: any): string => option.id,
  materialCategories: (option: any): string => option.id,
  medias: (option: any): string => option.id,
};
